import { useDispatch } from "react-redux";
import { callBackendApi } from "../axiosInstances/backendInstance/apiRequest";
import { addUser, logout } from "../../store/userSlice/userSlice";
import { useNavigate } from "react-router-dom";

export async function register(name, email, password) {
  const payload = {
    name,
    email,
    password,
  };

  return await callBackendApi("/register", "POST", payload);
}

export async function login(email, password) {
  const payload = {
    email,
    password,
  };

  const request = await callBackendApi("/login", "POST", payload);

  return request;
}

export const loginOauth = async (credentialResponse) => {
  const payload = {
    clientId: credentialResponse.clientId,
    credential: credentialResponse.credential,
  };

  const request = await callBackendApi("/login-oauth", "POST", payload);

  return request;
};

export const useFetchUser = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return async () => {
      const request = await callBackendApi("/user", "GET");

      if (!request.success) {
          dispatch(logout());
          navigate("/");
          return false;
      }

      dispatch(addUser(request.data.user));
      return true;
  };
};

export const logOut = async () => {
  const request = await callBackendApi("/logout", 'POST')

  return request
}